module.exports = __webpack_public_path__ + "static/renshi-c0105224a08c89d87c0ae3e630e35f8e.png";